import { FIELD_VALUES } from '@funnels/constants';
import { StoreApplicant } from '@funnels/types';

function defaultDisplay(value1: string = '', value2: string = '') {
  if (!value1 || !value2) {
    return `${value1}${value2}`;
  }

  return `${value1} ${value2}`;
}

export default function getApplicantDisplayName(
  applicant: StoreApplicant | undefined,
  display: (str1?: string, str2?: string) => string = defaultDisplay
): string {
  if (!applicant) {
    return display(undefined, undefined);
  }

  switch (applicant.entity) {
    case FIELD_VALUES.COMPANY:
      return display(applicant.companyName);
    case FIELD_VALUES.TRUST:
      return display(applicant.trustName);
    default:
      return display(applicant.firstName, applicant.lastName);
  }
}
